import Hero from "../../components/Hero";
import CalculatorsImag1 from "../../../assets/images/Calculator1.jpg";
import MortgageRepaymentCalculator from "../../calculators/MortgageRepaymentCalculator";

const MortgageRepaymentCalculatorsPage = () => {
  return (
    <div>
      <Hero
        title="Mortgage Repayment"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      <MortgageRepaymentCalculator/>
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default MortgageRepaymentCalculatorsPage;
